module.exports = __webpack_public_path__ + "static/img/1.75042f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ArticlesCoverChart/1.jpg
// module id = aMpJ
// module chunks = 2